<div class="modal" [@fade]
     [ngClass]="{
        'confirmation':alert.type == FuiAlertType.CONFIRMATION,
        'error':alert.type == FuiAlertType.ERROR,
        'warning':alert.type == FuiAlertType.WARNING,
        'success':alert.type == FuiAlertType.SUCCESS,
        'information':alert.type == FuiAlertType.INFORMATION
     }"
     *ngIf="alert && state">
    <div class="window">
        <div class="window-main">
            <div class="window-main-type" [ngSwitch]="alert.type">
                <div class="window-main-type-media" *ngSwitchCase="FuiAlertType.CONFIRMATION">
                    <fui-icon [icon]="'success'" [height]="28" [width]="28"></fui-icon>
                </div>
                <div class="window-main-type-media" *ngSwitchCase="FuiAlertType.ERROR">
                    <fui-icon [icon]="'error'" [height]="28" [width]="28"></fui-icon>
                </div>
                <div class="window-main-type-media" *ngSwitchCase="FuiAlertType.INFORMATION">
                    <fui-icon [icon]="'information'" [height]="28" [width]="28"></fui-icon>
                </div>
                <div class="window-main-type-media" *ngSwitchCase="FuiAlertType.WARNING">
                    <fui-icon [icon]="'error'" [height]="28" [width]="28"></fui-icon>
                </div>
                <div class="window-main-type-media" *ngSwitchCase="FuiAlertType.SUCCESS">
                    <fui-icon [icon]="'success'" [height]="28" [width]="28"></fui-icon>
                </div>
                <div class="window-main-type-label">
                    <div class="window-main-type-label-title" id="alert-label">
                        <span [innerHTML]="alert.title | translate:alert.params"></span>
                    </div>
                </div>
            </div>
            <div class="window-main-message">
                <div class="window-main-message-title" id="alert-message">
                    <span [innerHTML]="alert.message | translate:alert.params"></span>
                </div>
            </div>
            <ng-container *ngFor="let input of alert.inputs">
                <fui-edit-text-input *ngIf="input.type === FUIAlertInputType.TEXT" class="window-main-input"
                                     [forceRequired]="input.required" [label]="input.label"
                                     [(ngModel)]="inputs[input.name]"></fui-edit-text-input>
                <fui-edit-textarea-input *ngIf="input.type === FUIAlertInputType.TEXT_AREA" class="window-main-input"
                                         [forceRequired]="input.required" [label]="input.label"
                                         [(ngModel)]="inputs[input.name]"></fui-edit-textarea-input>
            </ng-container>
        </div>
        <div class="window-footer" [ngSwitch]="alert.type">
            <fui-choice-button *ngFor="let action of alert.actions" (click)="clickAction(action)"
                               [title]="action.label" [attr.action-name]="action.name"></fui-choice-button>
        </div>
    </div>
</div>
